import { isFeatureOn } from './appConfig';
import { isStoreBuild } from './platform';

/**
 * Показывать ли ученику «Удалить профиль».
 *
 * ⚠️ НА САЙТЕ СКРЫТО (D37, решение владельца 12.09.2026). Ученики нажимали
 * удаление, не могли войти и заводили новую учётку: прогресс и записи на курсы
 * оставались на мёртвой — отсюда часть дублей (задача 164). Удаление — одна
 * строка `status='deleted'`, вернуть её может только админ.
 *
 * ⚠️ В ПРИЛОЖЕНИИ ИЗ МАГАЗИНА — ВСЕГДА. Там есть саморегистрация, а Apple
 * (правило 5.1.1(v)) требует удаление внутри приложения; ревьюеру его показывали
 * («Profile → Settings → Delete account», `docs/app-review-reply-2026-08-24.md`).
 * Настройка с сервера здесь кнопку не прячет — иначе один тумблер отправил бы
 * сборку в отказ.
 *
 * Вернуть на сайте — `features.show_self_delete = true` в документе настроек,
 * без сборки. Проверка — `pages/student/selfDeleteHidden.test.ts`.
 */
export function selfDeleteShown(): boolean {
  return isStoreBuild() || isFeatureOn('show_self_delete');
}
